import * as React from 'react'
import Select from 'react-select'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import CheckboxOption from 'components/Select/CheckboxOption'
import './Select.scss'

interface SelectWrapperProps {
  name?: string
  id?: string
  value?: any[]
  options: any[]
  label?: string
  onChange?: (value: any) => void
}

interface SelectWrapperState {
  width: number
}

class MultiSelectWrapper extends React.Component<
  SelectWrapperProps,
  SelectWrapperState
> {
  constructor(props: SelectWrapperProps) {
    super(props)
    this.state = {
      width: window.innerWidth,
    }
  }

  public componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  // public getOptions(input: string, callback: any) {
  //     this.props.options.then((options) => {
  //         if (this.props.label) {
  //             options.unshift({value: -1, label: this.props.label, disabled: true});
  //         }
  //         callback(null, {options});
  //     });
  // }

  public handleResize = () => {
    this.setState({ width: window.innerWidth })
  }

  public handleChange = (value: any) => {
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  public handleMobileChange = (select: HTMLSelectElement) => {
    const result = []
    for (let i = 0; i < select.options.length; i++) {
      const opt = select.options[i]
      if (opt.selected) {
        const value = this.props.options.find(x => x.value === +opt.value)
        if (value) {
          result.push(value)
        }
      }
    }
    if (this.props.onChange) {
      this.props.onChange(result)
    }
  }

  public render() {
    const { value } = this.props

    return this.state.width <= 500 ? (
      <select
        id={this.props.id}
        name={this.props.name}
        className="srprs-select"
        multiple
        onChange={event => this.handleMobileChange(event.target)}
      >
        {this.props.options.map(option => {
          const selected = value
            ? value.map(x => x.value).includes(option.value)
            : false
          return (
            <option
              key={option.value}
              value={option.value}
              selected={selected}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          )
        })}
      </select>
    ) : (
      <Select
        multi
        onChange={this.handleChange}
        value={value}
        arrowRenderer={arrowRenderer}
        removeSelected={false}
        closeOnSelect={false}
        searchable={false}
        optionComponent={CheckboxOption}
        options={this.props.options}
      />
    )
  }
}

function arrowRenderer() {
  return <Icon icon={UI.chevronDown} />
}

export default MultiSelectWrapper
